var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0.6788 0.0081 508 508",
      "width": "200",
      "height": "200"
    }
  }, [_c('path', {
    staticStyle: {
      "fill": "#e6e9ee"
    },
    attrs: {
      "d": "M111.6,234.8L111.6,234.8L111.6,234.8z"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "x": "357.6",
      "y": "206.4",
      "width": "29.2",
      "height": "25.2"
    }
  }), _c('g', {
    attrs: {
      "id": "group-1",
      "stroke-width": "0",
      "transform": "matrix(1.491932988166809, 0, 0, 1.3672000169754028, 325.4457092285156, 159.37039184570312)"
    }
  }), _c('g', {
    attrs: {
      "id": "group-2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "transform": "matrix(1.491932988166809, 0, 0, 1.3672000169754028, 325.4457092285156, 159.37039184570312)"
    }
  }), _c('g', {
    attrs: {
      "id": "svg-1",
      "transform": "matrix(1, 0, 0, 1, -122.5798110961914, 2.918102979660034)"
    }
  }, [_c('g', {
    attrs: {
      "id": "group-4",
      "stroke-width": "0",
      "transform": "matrix(1, 0, 0, 1, 123.258591, -2.909988)"
    }
  }), _c('g', {
    attrs: {
      "id": "group-5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "transform": "matrix(1, 0, 0, 1, 123.258591, -2.909988)"
    }
  }), _c('g', {
    attrs: {
      "id": "group-6",
      "transform": "matrix(1, 0, 0, 1, 123.258591, -2.909988)"
    }
  }, [_c('path', {
    staticStyle: {
      "fill": "#2196f3"
    },
    attrs: {
      "d": "M508,254c0,140.4-113.6,254-254,254S0,394.4,0,254S113.6,0,254,0c110.8,0,204.8,70.8,239.6,169.6 c7.6,21.2,12,43.6,13.6,66.8C508,242.4,508,248,508,254z"
    }
  }), _c('polygon', {
    staticStyle: {
      "fill": "#f9b54c"
    },
    attrs: {
      "points": "203.6,303.2 177.2,303.2 150.8,303.2 146.8,311.6 177.2,337.6 207.6,311.6 "
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#2b3b4e"
    },
    attrs: {
      "d": "M46.4,400c46,64.4,121.6,106.4,206.8,106.4c28.8,0,56.8-4.8,82.4-13.6l-31.2-103.6L232,337.6h-54.8 h-54.8L50,388.8L46.4,400z"
    }
  }), _c('g', [_c('polygon', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "points": "232,337.6 215.2,393.2 177.2,337.6 207.6,311.6 "
    }
  }), _c('polygon', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "points": "122.4,337.6 139.2,393.2 177.2,337.6 146.8,311.6 "
    }
  })]), _c('path', {
    staticStyle: {
      "fill": "#e6e9ee"
    },
    attrs: {
      "d": "M139.2,393.2l30,98.4c4.8,1.6,9.6,3.2,14.8,4.8l31.2-103.2l-38-56L139.2,393.2z"
    }
  }), _c('polygon', {
    staticStyle: {
      "fill": "#54c0eb"
    },
    attrs: {
      "points": "177.2,337.6 156.4,368 161.2,375.2 177.2,375.2 193.2,375.2 198,368 "
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#84dbff"
    },
    attrs: {
      "d": "M177.2,375.2h-16l-18,103.6l3.6,4c14.8,6.8,30.8,12.4,47.2,16.4l17.6-20.4l-18-103.6H177.2z"
    }
  }), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#324a5e"
    },
    attrs: {
      "d": "M264.4,360.4L232,337.6l-48,159.2c3.2,0.8,6.4,2,10,2.8l50.4-59.2l-9.6-42.8l34.8,6.8L264.4,360.4z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#324a5e"
    },
    attrs: {
      "d": "M122.4,337.6L90,360.4L84.8,404l34.8-6.8l-9.6,43.2l36.4,42.8c7.2,3.2,14.8,6.4,22.4,9.2 L122.4,337.6z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#324a5e"
    },
    attrs: {
      "d": "M177.2,132c-42,0-76,35.6-76,79.2c0,9.2,1.6,17.6,4,25.6l0,0c2-1.2,4-2,6-2c0,0,29.6-29.2,47.6-55.6 c16.4,21.2,45.2,50,83.2,55.6c2.4,0,4.4,0.8,6,2l0,0c2.8-8,4-16.8,4-25.6C253.2,167.2,219.2,132,177.2,132z"
    }
  })]), _c('path', {
    staticStyle: {
      "fill": "#e6e9ee"
    },
    attrs: {
      "d": "M111.6,234.8L111.6,234.8L111.6,234.8z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ffd05b"
    },
    attrs: {
      "d": "M248.8,236.8c-2-1.2-4-2-6-2c-38.4-5.6-67.2-34.4-83.2-55.6c-18,26.4-47.6,55.6-47.6,55.6 c-2.4,0-4.4,0.8-6,2c-5.6,4-5.6,12.8-0.8,19.6c3.2,4,7.2,6.4,11.2,7.2c9.2,29.6,32.8,50.4,60.8,50.4s51.6-21.2,61.2-50.8 c4-0.4,8.4-2.8,11.2-7.2C254.8,249.6,254.4,240.8,248.8,236.8z"
    }
  }), _c('g', [_c('circle', {
    staticStyle: {
      "fill": "#324a5e"
    },
    attrs: {
      "cx": "208",
      "cy": "243.2",
      "r": "9.2"
    }
  }), _c('circle', {
    staticStyle: {
      "fill": "#324a5e"
    },
    attrs: {
      "cx": "146.4",
      "cy": "243.2",
      "r": "9.2"
    }
  })]), _c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M374.4,114.8c-55.6,0-100.8,38.4-100.8,85.6c0,17.2,6,33.6,16.4,47.2l-30.4,85.2l84.4-50.4 c9.6,2.4,19.6,4,30,4c55.6,0,100.8-38.4,100.8-85.6C475.2,153.2,430,114.8,374.4,114.8z"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "x": "357.6",
      "y": "206.4",
      "width": "29.2",
      "height": "25.2"
    }
  })])]), _c('g', {
    attrs: {
      "id": "group-3",
      "transform": "matrix(1.491932988166809, 0, 0, 1.3672000169754028, 326.7334289550781, 156.67637634277344)"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#428bc1",
      "d": "M0 46.5h64v9H0z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#42ade2",
      "d": "M0 8.5h64v38H0z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#94989b",
      "d": "M24 46.5h16v9H24z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#428bc1",
      "d": "M4 12.5h56v30H4z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#42ade2",
      "d": "M7 15.5h50v24H7z"
    }
  }), _c('circle', {
    attrs: {
      "cx": "45",
      "cy": "27.5",
      "r": "8",
      "fill": "#428bc1"
    }
  }), _c('path', {
    attrs: {
      "fill": "#d0d0d0",
      "d": "M24 8.5h16v38H24z"
    }
  }), _c('path', {
    attrs: {
      "d": "M19.3 33.5c-2.2 0-4.2-1.2-5.2-3h6.7v-2h-7.4c-.1-.3-.1-.7-.1-1s0-.7.1-1h7.4v-2h-6.7c1.1-1.8 3-3 5.2-3c.4 0 .8 0 1.2.1l.5-2c-.5-.1-1.1-.2-1.7-.2c-3.4 0-6.4 2.1-7.6 5H9v2h2.2c0 .3-.1.7-.1 1s0 .7.1 1H9v2h2.7c1.2 2.9 4.2 5 7.6 5c.6 0 1.1-.1 1.7-.2l-.5-2c-.3.3-.8.3-1.2.3",
      "fill": "#ffffff"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }